import { Component } from '@angular/core';

@Component({
  templateUrl: '500.component.html'
})
export class P500Component {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/pages/500.component.ts